// Favorite faces (PLAN-2026-10-24-faces-round-three §1, scenario L2): faces a
// person keeps on the account to put back on later, on any of their teams, so
// trying more ideas in the face maker never loses one worth keeping.
//
// `GET /api/me/faces` answers the account's favorites, newest first; `POST`
// saves one (`FaceFavoriteSave`) and `DELETE /api/me/faces/:id` takes one
// out, and both answer the list again. A favorite is the face alone, its
// parts, colors and steps, without a team's two colors, which are the team's.
//
// `earned` rides along because the maker needs it at the same moment: the
// achievements this account holds that earn a face's part (§5).

import { z } from 'zod';
import { Face } from '../teams/faces';

/** How many faces one account keeps: a drawer of favorites, not an archive. */
export const FACE_FAVORITES_MAX = 24;

export const FaceFavorite = z.object({
  /** The store's own id for it, which `DELETE` names. */
  id: z.string(),
  face: Face,
  savedAt: z.string(),
});
export type FaceFavorite = z.infer<typeof FaceFavorite>;

export const FaceFavoritesView = z.object({
  /** Newest first. */
  faces: z.array(FaceFavorite),
  /** How many the account keeps (`FACE_FAVORITES_MAX`). */
  max: z.number().int().min(1),
  /**
   * The achievements this account has earned that earn a face's part, by id
   * (`FacePart.earnedBy`). Empty when it has earned none of them.
   */
  earned: z.array(z.string()),
});
export type FaceFavoritesView = z.infer<typeof FaceFavoritesView>;

/** `POST /api/me/faces`: the face to keep. */
export const FaceFavoriteSave = z.object({ face: Face });
export type FaceFavoriteSave = z.infer<typeof FaceFavoriteSave>;
